<script>
import GlobalVue from '@helper/Global.vue';
import BaseVue from '@frontend/Base.vue';
import Gen from '@helper/Gen';

// import swal from 'sweetalert';

export default {
  extends:GlobalVue,
  mounted(){
    this.refreshMeta()
  },
  methods:{
    refreshMeta(){
      console.log('meta-info')
      Gen.rest(this.$route.path, {metainfo:true},(err,resp)=>{
        if(err) return console.error(err)
        $("title").text(resp.meta_title)
        $("meta[property='og:image']").attr('content', resp.ss_img)
        $("meta[property='og:title']").attr('content', resp.meta_title)
        $("meta[name='description']").attr('content', resp.ss_meta_desc)
        $("meta[property='og:description']").attr('content', resp.ss_meta_desc)
        $("meta[name='keywords']").attr('content', resp.ss_meta_keyword)
        $("meta[name='author']").attr('content', resp.ss_author)
        $("meta[property='og:site_name']").attr('content', resp.ss_sitename)
        $("meta[property='url']").attr('content', resp.ss_url)
        $("link[rel='canonical']").attr('content', resp.ss_url)
        this.$root.meta = resp
      })
    },
  },
  watch:{
    $route(){
      this.refreshMeta()
    }
  }
}

</script>
